/* eslint-disable react/no-array-index-key */

'use client';

import { Box, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';

const GREEN_LIGHT = '#E1F5EE';
const GREEN = '#1D9E75';

const PARTNERS = [
  { src: '/images/landing/partner-malakoff-humanis.webp', alt: 'Malakoff Humanis' },
  { src: '/images/landing/partner-neoliane.webp', alt: 'Neoliane' },
  { src: '/images/landing/partner-solly-azar.webp', alt: 'Solly Azar' },
  { src: '/images/landing/partner-allianz.webp', alt: 'Allianz' },
  { src: '/images/landing/partner-alptis.webp', alt: 'Alptis' },
  { src: '/images/landing/partner-cegema.webp', alt: 'CEGEMA' },
  { src: '/images/landing/partner-apicil.webp', alt: 'APICIL' },
  { src: '/images/landing/partner-swiss-life.webp', alt: 'Swiss Life' },
];

const SETS_PER_LOOP = 3;

function LogoTrack() {
  const oneLoop = Array.from({ length: SETS_PER_LOOP }, () => PARTNERS).flat();
  const allLogos = [...oneLoop, ...oneLoop];

  return (
    <Box position="relative" overflow="hidden">
      {/* eslint-disable-next-line react/no-danger */}
      <style
        dangerouslySetInnerHTML={{
          __html:
            '@keyframes scrollLogos{from{transform:translateX(0)}to{transform:translateX(calc(-50% - 16px))}}',
        }}
      />
      <Box
        position="absolute"
        top={0}
        bottom={0}
        left={0}
        w="80px"
        zIndex={2}
        css={{ background: 'linear-gradient(to right, #fff, transparent)' }}
      />
      <Box
        position="absolute"
        top={0}
        bottom={0}
        right={0}
        w="80px"
        zIndex={2}
        css={{ background: 'linear-gradient(to left, #fff, transparent)' }}
      />
      <Flex
        gap="32px"
        alignItems="center"
        whiteSpace="nowrap"
        style={{
          animation: 'scrollLogos 90s linear infinite',
          width: 'max-content',
        }}
        _hover={{ animationPlayState: 'paused' }}
      >
        {allLogos.map((partner, i) => (
          <Flex
            key={`${partner.alt}-${i}`}
            flexShrink={0}
            align="center"
            justify="center"
            bg="#f5f5f5"
            borderRadius="8px"
            px="24px"
            h="56px"
            transition="background 0.2s, color 0.2s"
            _hover={{ bg: GREEN_LIGHT, color: GREEN }}
          >
            <Box position="relative" w="100px" h="32px">
              <Image src={partner.src} alt={partner.alt} fill style={{ objectFit: 'contain' }} />
            </Box>
          </Flex>
        ))}
      </Flex>
    </Box>
  );
}

export default function PartnersSection() {
  return (
    <Box as="section" pt="3rem" pb="2.5rem" overflow="hidden" borderBottom="1px solid #E5E7EB">
      <Text textAlign="center" fontSize="13px" color="#999" letterSpacing="0.08em" textTransform="uppercase" mb="24px">
        Nos assureurs partenaires
      </Text>
      <LogoTrack />
    </Box>
  );
}
